import { openReviewer, openAcademic } from '@/api/open'
export default {
  data() {
    return {
      key: '',
      reviewskey: ''
    }
  },
  mounted() {
    this.key = this.$route.query.key
    this.reviewskey = this.$route.query.reviewskey
    this.reviewstype = this.$route.query.reviewstype
    this.decisionKey = this.$route.query.decisionKey
    this.decisionType = this.$route.query.decisionType
    if (this.reviewskey) {
      this.reviewsManuscript()
    } else if (this.decisionKey) {
      this.academicManuscript()
    }
  },
  methods: {
    // 获取稿件信息
    async reviewsManuscript() {
      const data = await openReviewer.reviewsCode(this.reviewskey)
      const { id, status } = data
      if (!data) {
        return
      }
      let url =
        status === 'AGREED'
          ? 'agree'
          : this.reviewstype === 'agree'
          ? 'confirm'
          : this.reviewstype === 'refuse'
          ? 'refuse'
          : ''
      if (['NO_RESPONSE', 'AGREED'].includes(data.status)) {
        this.$router.push(
          `/email-url/review-${url}?reviewskey=${this.reviewskey}`
        )
      } else if (['DECLINED', 'TERMINATED_BY_EDITOR'].includes(data.status)) {
        this.$router.push(`/email-url/invalid-page?code=${this.reviewskey}`)
      } else {
        this.$router.push(
          `/email-url/review-view?reviewskey=${this.reviewskey}`
        )
      }
    },
    async academicManuscript() {
      const data = await openAcademic.academicCode(this.decisionKey)
      if (!data) {
        return
      }
      if (
        [
          'PRE_CHECK_DONE',
          'FIRST_DECISION_DONE',
          'FINAL_DECISION_DONE'
        ].includes(data.status)
      ) {
        // 详情页
        this.$router.push(
          `/email-url/academic-agree/detail?decisionKey=${this.decisionKey}&decisionType=${this.decisionType}`
        )
        return
      } else if (['TERMINATED_BY_EDITOR'].includes(data.status)) {
        this.$router.push(
          `/email-url/invalid-page?code=${this.decisionKey}&decisionType=${this.decisionType}`
        )
      } else {
        this.$router.push(
          `/email-url/academic-agree?decisionKey=${this.decisionKey}&decisionType=${this.decisionType}`
        )
      }
    }
  }
}
